import { AppStore } from "../store/store.ts";
import { debug } from "../utilities/logger.ts";
import { startKeepAlive, stopKeepAlive } from "./websocket-keep-alive.ts";
import { webSocketGetter, webSocketSetter } from "./websocket-store.ts";
import { produceWebsocket, sendWsMetricsEvents } from "./websocket-utils.ts";
import { startAppListening } from "../utilities/session-state-change-listener.ts";
import { CoralogixLogSeverity, CoralogixRum } from "@coralogix/browser";
import { envFlag } from "../utilities/env-util.ts";

export default function createWebsocket(store: AppStore, ws_endpoint: string) {
  const WS_HOST =
    ws_endpoint ||
    import.meta.env.VITE_DEV_API_ENDPOINT_WS ||
    "fe.conteprestiti.it";
  const enableMock = envFlag("VITE_ENABLE_MOCKS", import.meta.env) ?? false;

  //LISTEN FOR SESSION CHANGES
  startAppListening({
    predicate: (_, current, previous) =>
      current.session !== previous.session || current.loan !== previous.loan,

    effect: async (_) => {
      const ws = webSocketGetter();
      sendWsMetricsEvents(store, ws);
    },
  });

  //LISTEN FOR TOKEN CHANGES
  startAppListening({
    predicate: (_, current, previous) =>
      current.session.token !== previous.session.token,

    effect: async (_, api) => {
      if (enableMock) {
        return;
      }

      const { token } = api.getState().session;

      if (!token) {
        debug("[WS]: Token is undefined, closing websocket");
        CoralogixRum.log(
          CoralogixLogSeverity.Debug,
          "[WS]: Token is undefined, closing websocket",
        );
        return;
      }

      const ws = webSocketGetter();

      if (typeof ws === "undefined") {
        const newWs = produceWebsocket(store, WS_HOST);

        if (typeof newWs === "undefined") {
          return;
        }
        webSocketSetter(newWs);

        return;
      }
    },
  });

  //LISTEN FOR KEEPALIVE CHANGES
  startAppListening({
    predicate: (_, current, previous) =>
      current.session.keepAlive !== previous.session.keepAlive,

    effect: async (_, api) => {
      if (enableMock) {
        return;
      }

      const { keepAlive } = api.getState().session;

      return keepAlive
        ? startKeepAlive(store, webSocketGetter, WS_HOST)
        : stopKeepAlive();
    },
  });
}
